module.exports = __webpack_public_path__ + "media/images/sports_icons/016-cycling-9126e0dccc456862f79270d44d09e87e.png";